<template>
  <a
      class="columns"
      @mouseover="hover = true"
      @mouseleave="hover = false"
      @click="clickHandler">
    <div class="column is-11">
      {{ option.libelleNomCommercial }}
    </div>
    <div class="column is-1">
      <b-icon
          v-if="hover"
          type="is-primary"
          size="is-small"
          class="icon is-pulled-right"
          icon="open-in-new">
      </b-icon>
    </div>
  </a>
</template>

<script>
export default {
  props: {
    option: {
      type: Object,
      required: true,
    },
    path: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      hover: false,
    };
  },
  methods: {
    clickHandler() {
      if (this.option === null) return;
      window.open(
        this.$router.resolve(
          {
            name: this.path,
            params: { id: this.option.id, sousTypeFrom: this.option.sousTypes[0] },
          },
        ).href,
      );
      this.$emit('openTab');
    },
  },
};
</script>

<style>

</style>
